
export function xslog(...message: any[]) {
    console.log("XSFuneral", ...message);
}